import axios from 'axios';
import { BASE_URL } from '@/helpers/apiUtilities.js';
import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr';

const state = {
  connection: null
};

export const mutations = {
  resetData: function (state) {
    state.connection = null;
  },
  setConnection: function (state, connection) {
    state.connection = connection;
  }
};

export const actions = {
  resetData: function (store) {
    if (store.state.connection) {
      store.state.connection.stop();
    }
    store.commit('resetData');
  },
  createConnection: function (store, userId) {
    store.dispatch('negotiateConnection', userId)
      .then(({ url, token }) => {
        const connection = new HubConnectionBuilder()
          .withUrl(url, {
            accessTokenFactory: () => token
          })
          .configureLogging(LogLevel.Error)
          .build();
        store.commit('setConnection', connection);
        store.dispatch('setupSignalR')
          .then(() => {
            connection.start();
          });
      });
  },
  negotiateConnection: function (store, userId) {
    const options = {
      headers: {
        userId
      }
    };

    return axios.get(BASE_URL + '/SignalR/Messages/Negotiate', options)
      .then(response => {
        return {
          token: response.data.accessToken,
          url: response.data.url
        };
      });
  },
  setupSignalR: function (store) {
    const connection = store.state.connection;
    return Promise.all([
      store.dispatch('setupSignalR', connection, { root: true })
    ]);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
